﻿import TKTabsTab from "@tk/controls/tk.tabs.tab";

export default class KWTabsTab extends TKTabsTab {
    outsideElements: NodeListOf<HTMLElement>;
    directLinkAttribute: string;
    shouldShowOutsideElement: boolean;
    hasURLParams: boolean;

    constructor() {
        super();

        this.outsideElements = document.querySelectorAll(
            "[data-tk-outside-element]"
        );
        this.directLinkAttribute = "data-tk-is-direct-link";
        this.shouldShowOutsideElement = this.hasAttribute(
            "data-tk-show-outside-element"
        );
        this.hasURLParams = this.hasAttribute("data-tk-has-url-params");
    }

    connectedCallback(): void {
        this.registerListener();
        if (this.tabList && Number(this.initialTabIndex) > 0) {
            const button = this.tabList.item(
                this.initialTabIndex - 1
            ) as HTMLButtonElement;
            this.setTabActive(button, this.initialTabIndex - 1, true);
        }
    }

    setTabActive(
        button: HTMLButtonElement,
        index: number,
        isInit = false
    ): void {
        if (this.hasURLParams) {
            const url = new URL(window.location.href);
            url.searchParams.set("tab", `${index + 1}`);
            window.history.pushState({}, "", url);
        }
        // Workaround: .bind() überschreibt Standardwerte, daher Typprüfung für isInit
        if (typeof isInit !== "boolean") {
            // eslint-disable-next-line no-param-reassign
            isInit = false;
        }

        const input = button.querySelector("input");
        if ((input && input.disabled) || button.disabled) return;
        const item = this.tabContentList?.item(index);
        if (
            !item ||
            (button.hasAttribute(this.directLinkAttribute) && !isInit)
        ) {
            const url = button.getAttribute("data-tk-url");
            const target = button.getAttribute("target") || undefined;
            if (!url) return;
            window.open(url, target);
        } else {
            this.setTabInactive();
            button.classList.add(this.activeClassName);
            item.classList.add(this.activeClassName);
        }
        this.toggleRequiredAttribute(index);
        this.shouldShowOutsideElement && this.showOutsideElement(index);
    }

    showOutsideElement(index: number) {
        this.hideAllOutsideElements();
        Array.from(this.outsideElements)
            .filter(
                (element) =>
                    Number(element.getAttribute("data-tk-outside-element")) ===
                    index
            )
            .forEach((element) => {
                element.hidden = false;
            });
    }

    hideAllOutsideElements() {
        this.outsideElements.forEach((element) => {
            element.hidden = true;
        });
    }
}
